import { ProjectColoredBadge, ProjectColoredLink } from "@selector/shared/components";

import { isColumnExpanded } from "@/redux/modules/table-data.js";

import type { Project } from "../../../../graphql.js";
import type { IAgGridCellProps } from "../cell-base-interfaces.js";

const ProjectListCell = (props: IAgGridCellProps) => {
  const { colDef, context, data, value } = props;

  if (!value) {
    return null;
  }

  const useExternal = colDef.openLinkExternal;
  const cellExpanded = context?.expansionPath ? isColumnExpanded(colDef, context.expansionPath) : false;
  const projects: Project[] = data.projects;

  return cellExpanded || projects.length <= 1 ? (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column", paddingTop: 4 }}>
      {projects.map((project: Project, index: number) => (
        <ProjectColoredLink
          key={`item-${index}`}
          project={project}
          style={{ display: "flex", height: "19px", lineHeight: "19px" }}
          forceExternal={useExternal}
        />
      ))}
    </div>
  ) : (
    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 6, height: "100%" }}>
      {projects.map((project: Project, index: number) => (
        <div key={`item-${index}`} style={{ display: "inline-block", verticalAlign: "middle" }}>
          <ProjectColoredBadge project={project} size={"small"} />
        </div>
      ))}
    </div>
  );
};

export default ProjectListCell;
